export {}; // Using the export, there is no need to import the file anywhere.

// Extend the Array prototype to add the filterAndTransform method

type FilteredResult<U> = {
	[K in keyof U]?: U[K];
};

// @ts-ignore
declare global {
	interface Array<T> {
		reduceObjectKeys<K extends keyof T>(this: T[], criteriaKeys: K[]): Array<Pick<T, K>>;
	}
}

Array.prototype.reduceObjectKeys = function <T, K extends keyof T>(this: T[], criteriaKeys: K[]): Array<Pick<T, K>> {
	if (!(this instanceof Array)) return new Array<Pick<T, K>>();

	return this.map(item => {
		return Object.fromEntries(
			Object.entries(item).filter(([key]) => criteriaKeys.includes(key as K))
		) as Pick<T, K>;
	});
};
